import { api } from "../utils/api";
import type { RestStockPolicy } from "@KassaroAB/shared/types/stockPolicy";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const getStockPoliciesApi = (
  chainId: ChainId,
): Promise<RestStockPolicy[]> => {
  return api.get(`chains/${chainId}/stockPolicies`);
};
